import { TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'

const Tablehead = ({ data }) => {
    return (
        <TableHead>
            <TableRow> {data?.map((item) =>
                <TableCell><strong>{item}</strong></TableCell>
            )}
            </TableRow>
        </TableHead>
    )
}

export default Tablehead